<script setup lang="ts">
import Card from "primevue/card";
import BaseSkeletonLoader from "@/components/shared/loaders/BaseSkeletonLoader.vue";

const ptStyling = {
  body: {
    class: "flex flex-col flex-grow gap-2 p-4",
  },
  content: {
    class: "font-normal text-sm leading-[163%] text-[#334155]",
  },
  caption: {
    class: "flex flex-col flex-grow gap-2",
  },
  footer: {
    class: "pt-0",
  },
};
</script>
<template>
  <div class="flex flex-col flex-grow w-full">
    <Card
      class="flex flex-col flex-grow rounded-2x1 !shadow-md bg-white gap-2 overflow-hidden"
      :pt="ptStyling"
      data-testid="my-experiences-summary-card-skeleton"
    >
      <template #header>
        <BaseSkeletonLoader width="w-full" height="h-48" />
      </template>
      <template #title>
        <BaseSkeletonLoader width="w-3/4" height="h-5" />
      </template>
      <template #subtitle>
        <BaseSkeletonLoader width="w-1/2" height="h-4" />
      </template>
      <template #content>
        <div class="flex flex-col gap-2">
          <BaseSkeletonLoader width="w-2/3" height="h-4" />
          <BaseSkeletonLoader width="w-3/5" height="h-4" />
        </div>
      </template>
      <template #footer>
        <div class="flex flex-row-reverse w-full p-0">
          <BaseSkeletonLoader width="w-24" height="h-9" class="rounded-md" />
        </div>
      </template>
    </Card>
  </div>
</template>
